import type { StoreLocalizedString } from '../../codegen/types';
import { Locale } from './localeHelper';

export function getLocale(values: StoreLocalizedString[], localeToFind?: string) {
  return (
    values.find(({ locale }) => locale.toLowerCase() === localeToFind?.toLowerCase()) ||
    values.find(({ locale }) => locale.toLowerCase() === Locale.DEFAULT_LOCALE)
  );
}
